import * as React from "react";

function Volume2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M19 1.957v28.09L8.657 22.001H2v-12h6.657L19 1.957zm-2 4.09l-7.657 5.955H4v8h5.343L17 25.957V6.047zm6.085 4.433a8.91 8.91 0 010 11.04l-1.57-1.24a6.91 6.91 0 000-8.56l1.57-1.24zm3.584-3.62a14.42 14.42 0 013.33 9.128 13.69 13.69 0 01-3.344 9.166l-1.51-1.31A11.69 11.69 0 0028 16.014v-.01a12.421 12.421 0 00-2.87-7.866l1.539-1.279z",
    clipRule: "evenodd"
  }));
}

export default Volume2Icon;